export const TAKE_BATTERY_SUCCESS = 'take_battery_success'
export const TAKE_BATTERY_ERROR = 'take_battery_error'
export const TIMEOUTED = 'timeouted'
export const FIRMWARE_COMMUNICATION_ERROR = 'firmware_communication_error'
export const CANCELLED_BY_CUSTOMER = 'canceled_by_customer'
export const VALIDATION_ERROR = 'validation_error'

export const TAKE_BATTERY_IN_PROGRESS_STATUSES = [
  'in_queue',
  'take_battery_start',
  'take_battery',
  'start',
  'validation_success',
  'payment_confirmed'
]

export const TAKE_BATTERY_FAILURE_STATUSES = [
  TAKE_BATTERY_ERROR,
  TIMEOUTED,
  FIRMWARE_COMMUNICATION_ERROR,
  CANCELLED_BY_CUSTOMER,
  VALIDATION_ERROR,
  'abandoned',
  'payment_expired',
  'fraud_suspected'
]

export const VALIDATION_SUCCESS = 19
export const VALIDATION_CODE_LENGTH = 6
export const CABLE_TYPE_LIGHTNING = 0
export const CABLE_TYPE_MICRO = 1
export const CABLE_TYPE_USBC = 2
export const SUCCESS_MSG = 'Cartão cadastrado com sucesso'
export const FAIL_MSG = 'An error occured'
export const FIVE_MINUTES = 5 * 60

export const TAKE_DEMONSTRATION = 'takeDemonstration'
export const PRICE_TABLE = 'priceTable'

export const SIDE_BAR = 'sideBar'
export const FAILED_DIALOG = 'failedDialog'
export const LAST_TRANSACTION_INFO = 'lastTransactionInfo'
export const RATING_TRANSACTION = 'ratingTransaction'
export const RENT_SUCCESS = 'rentSuccess'

export const RETRY_TAKE_BATTERY_INTERVAL = 5000
export const USER_INFO_SHARING_PERMISSION_GRANTED = 2
export const USER_INFO_SHARING_PERMISSION_REFUSED = 3
export const CREDIT_CARD_RESERVATION_ALLOW = 2
export const PAYMENT_TIMEOUTED = 17
export const PAYMENT_METHOD_CREDIT_CARD = 1
export const PAYMENT_METHOD_PIX = 3

export const EXPERIMENTS = {}

export const RETURN_SUCCESS_LIST = [
  'return_battery_success',
  'return_by_panel_success',
  'return_battery_unlocked',
  'battery_lost'
]

// antes da requisição de validação ser feita, é necessário que se saiba se haverá retentativa ou não pelo backend. Por esse motivo, se for considerado o tempo da última atividade na estação com um número de realista, 10 ou 30 (minutos), é necessário ao menos 1 retentativa
export const RETRY_VALIDATION_COUNT = parseInt(import.meta.env.VITE_RETRY_VALIDATION_COUNT) || 1
export const RETRY_TAKE_BATTERY_COUNT = parseInt(import.meta.env.VITE_RETRY_TAKE_BATTERY_COUNT) || 1
export const MINUTES_SINCE_LAST_ACTIVITY_TO_RETRY =
  parseInt(import.meta.env.VITE_MINUTES_SINCE_LAST_ACTIVITY_TO_RETRY) || -1
export const REFRESH_ALLOWED = parseInt(import.meta.env.VITE_REFRESH_ALLOWED) || 2
export const MINUTES_TO_EXPIRE_PIX_DATA = parseInt(import.meta.env.VITE_MINUTES_TO_EXPIRE_PIX_DATA) || 1440

import { ErrorCodes } from '@/errors'

export const ERRORS_TO_RETRY = [ErrorCodes.TERMINAL_OFFLINE, ErrorCodes.REQUEST_IN_PROGRESS]

export const TOKENS_PARTNERS = Object.freeze({
  PINAPPLES: Object.freeze({
    name: 'pinapples',
    token: '7210'
  })
})
